const TOAST_Z_INDEX = "var(--azm-z-toast, 110000)";

const OVERLAY_NODE_CLASSES = [
	"cdk-overlay-container",
	"cdk-overlay-backdrop",
	"cdk-overlay-pane",
	"cdk-global-overlay-wrapper",
	"cdk-dialog-container",
] as const;

type PopoverHost = HTMLElement & {
	showPopover?: () => void;
	hidePopover?: () => void;
	matches: (selector: string) => boolean;
};

function getToastContainer(): HTMLElement | null {
	return (
		document.getElementById("toast-container") ??
		document.querySelector<HTMLElement>(".toast-container.toast-top-right, .toast-container.toast-top-center")
	);
}

function isOverlayNode(node: Node): boolean {
	return (
		node instanceof HTMLElement &&
		(OVERLAY_NODE_CLASSES.some((className) => node.classList.contains(className)) || node.tagName === "AZM-LOADING")
	);
}

function promoteToastToTopLayer(toastContainer: HTMLElement): void {
	const host = toastContainer as PopoverHost;

	if (typeof host.showPopover !== "function") {
		return;
	}

	if (host.getAttribute("popover") !== "manual") {
		host.setAttribute("popover", "manual");
	}

	try {
		if (host.matches(":popover-open") && typeof host.hidePopover === "function") {
			host.hidePopover();
		}

		host.showPopover();
	} catch {
		if (!host.matches(":popover-open")) {
			host.removeAttribute("popover");
		}
	}
}

export function elevateToastOverlay(): void {
	const toastContainer = getToastContainer();

	if (!toastContainer) {
		return;
	}

	toastContainer.style.setProperty("z-index", TOAST_Z_INDEX, "important");
	document.body.appendChild(toastContainer);
	promoteToastToTopLayer(toastContainer);
}

let observer: MutationObserver | undefined;

export function keepToastOverlayElevated(): void {
	if (observer) {
		return;
	}

	observer = new MutationObserver((records) => {
		const shouldElevate = records.some((record) => [...record.addedNodes].some(isOverlayNode));

		if (shouldElevate) {
			elevateToastOverlay();
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
}
